import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

// Pages publiques
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

// Espaces privés (chargement paresseux)
const AdminDashboard = React.lazy(() => import('./pages/admin/AdminDashboard'));
const ProfEspace = React.lazy(() => import('./pages/prof/ProfEspace'));
const ParentEspace = React.lazy(() => import('./pages/parent/ParentEspace'));

const Spinner = () => (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
);

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <React.Suspense fallback={<Spinner />}>
                    <Routes>
                        {/* Public */}
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="/reset-password" element={<ResetPasswordPage />} />

                        {/* Admin */}
                        <Route
                            path="/admin/*"
                            element={
                                <PrivateRoute role="ADMIN">
                                    <AdminDashboard />
                                </PrivateRoute>
                            }
                        />

                        {/* Professeur */}
                        <Route
                            path="/prof/*"
                            element={
                                <PrivateRoute role="PROF">
                                    <ProfEspace />
                                </PrivateRoute>
                            }
                        />

                        {/* Parent */}
                        <Route
                            path="/parent/*"
                            element={
                                <PrivateRoute role="PARENT">
                                    <ParentEspace />
                                </PrivateRoute>
                            }
                        />

                        {/* Redirection racine → login */}
                        <Route path="/" element={<Navigate to="/login" replace />} />
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                </React.Suspense>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
